// Module
var code = "<div class=\"panel panel-default\"> <div class=\"panel-body text-muted text-center\"> Custom Component ({{ component.type }}) </div> </div> ";
// Exports
export default code;